// extracted by mini-css-extract-plugin
export default {"send_part":"send_send_part__8Bhma","send":"send_send__ksLDx"};